import React, { useEffect, useState } from "react";
import { getHome } from "../api/client";
import { Link } from "react-router-dom";

import HeroSection from "../components-page/home/HeroSection";
import AboutTeaser from "../components-page/home/AboutTeaser";
import ServicesPreview from "../components-page/home/ServicesPreview";
import WhyChooseUs from "../components-page/home/WhyChooseUs";
import StatsSection from "../components-page/home/StatsSection";
import ProjectsPreview from "../components-page/home/ProjectsPreview";
import Testimonials from "../components-page/home/Testimonials";
import CtaSection from "../components-page/home/CtaSection";

const Home = ({ settings, lang }) => {
    const [data, setData] = useState({ services: [], projects: [], static_en: {}, static_ar: {} });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getHome();
                // Assuming structure: { services: [], projects: [], static_en: {}, static_ar: {}, ... }
                if (response.data) {
                    setData({
                        services: response.data.services || [],
                        projects: response.data.featured_projects || response.data.projects || [],
                        static_en: response.data.static_en || {},
                        static_ar: response.data.static_ar || {}
                    });
                }
            } catch (error) {
                console.error("Failed to fetch home data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const getText = (en, ar) => (lang === "en" ? en : ar);
    const getStatic = (key, fallback) => {
        return lang === "en" ? (data.static_en[key] || fallback) : (data.static_ar[key] || fallback);
    }

    // Changes: t function now pulls from global 'settings' prop as requested (/api/settings)
    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };

    useEffect(() => {
        document.title = getStatic("page_title_home", "إينوبريدج | الاستشارات الاستراتيجية والتحول الرقمي");

        // Update meta description
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
            metaDesc.setAttribute("content", getStatic("meta_description_contact", "إينوبريدج | الاستشارات الاستراتيجية والتحول الرقمي"));
        }

        // Update meta keywords
        const metaKeywords = document.querySelector("meta[name='keywords']");
        if (metaKeywords) {
            metaKeywords.setAttribute("content", getStatic("meta_keyword_contact", "إينوبريدج | الاستشارات الاستراتيجية والتحول الرقمي"));
        }
    }, [lang, data.static_en, data.static_ar]);



    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader

    return (
        <>
            <HeroSection t={t} lang={lang} data={data} />
            <AboutTeaser t={t} lang={lang} data={data} />
            <ServicesPreview t={t} lang={lang} data={data} loading={loading} />
            <WhyChooseUs t={t} lang={lang} data={data} />
            <StatsSection t={t} lang={lang} />
            <ProjectsPreview t={t} lang={lang} data={data} loading={loading} />
            <Testimonials t={t} lang={lang} />
            <CtaSection t={t} lang={lang} />
        </>
    );
};

export default Home;
